var catIdent = 0;
var timeDelayForCatMenu = 300;

$('.cat-menu-col__btn-mobile').on('click', function () {
    setTimeout(
        function () {
            $(this).css('display', 'none');
            $('#mobile-sandwich').removeClass('active');
            $('.cat-menu, .cat-menu-col__txt, .btn--cat-menu-col').css(
                'display',
                'block'
            );
            catalogMenuPositionDefine(lastScrollTop);
        }.bind(this),
        timeDelayForCatMenu + 50
    );
});
$('.cat-menu__head-cross').on('click', function () {
    setTimeout(
        function () {
            $('.cat-menu-col__btn-mobile').css('display', 'block');
            $('.cat-menu, .cat-menu-col__txt, .btn--cat-menu-col').css(
                'display',
                'none'
            );
            catalogMenuPositionDefine(lastScrollTop);
        }.bind(this),
        timeDelayForCatMenu
    );
});

function catalogMenuPositionDefine(lastScrollTop) {
    var res = resolutionCheck();
    var menu;
    if (res >= 128) {
        menu = $('.cat-menu-col__inner');
    } else {
        if ($('.center__cat-inner').hasClass('active')) {
            menu = $('.cat-menu-col__inner');
        } else {
            menu = $('.cat-menu-col__btn-mobile');
        }
    }
    if (res > 32) {
        var lastScrollTop = lastScrollTop;
        var wS = $(window).scrollTop();

        var elementToFixed = $('.cat-menu-col__inner');
        var elementToFixedWrap = $('.cat-menu-col');
        var menuHeight = menu.height();
        var catListHeight = $('.cat-list__inner').outerHeight(true);
        var catListMargin = parseInt($('.center--catalog').css('margin-top'));

        var menuPos =
            $('.page-title').outerHeight() +
            $('header').height() +
            parseInt($('.page-content--catalog').css('padding-top')) +
            $('.center--cat-controls').height() +
            catListMargin;

        var toBottomFixed = parseInt(menuPos + catListHeight);

        if (menuHeight < catListHeight) {
            if (wS <= menuPos) {
                catIdent = 0;
                elementToFixedWrap.removeClass('menu-to-bottom');
                elementToFixed.removeClass('fixed');
            }
            if (wS > lastScrollTop) {
                if (
                    wS >= menuPos &&
                    menuHeight <= toBottomFixed - wS &&
                    catIdent != 1
                ) {
                    elementToFixedWrap.removeClass('menu-to-bottom');
                    elementToFixed.addClass('fixed');
                } else if (menuHeight > toBottomFixed - wS) {
                    catIdent = 1;
                    elementToFixedWrap.addClass('menu-to-bottom');
                    elementToFixed.removeClass('fixed');
                }
            } else {
                if (wS >= menuPos && menuHeight <= toBottomFixed - wS) {
                    elementToFixedWrap.removeClass('menu-to-bottom');
                    elementToFixed.addClass('fixed');
                } else if (wS >= menuPos && menuHeight <= toBottomFixed - wS) {
                    elementToFixedWrap.addClass('menu-to-bottom');
                    elementToFixed.removeClass('fixed');
                }
            }
        }
    }
}

function onLoadPosDefine() {
    var res = resolutionCheck();
    if (res >= 128) {
        menu = $('.cat-menu-col__inner');
    } else {
        if ($('.center__cat-inner').hasClass('active')) {
            menu = $('.cat-menu-col__inner');
        } else {
            menu = $('.cat-menu-col__btn-mobile');
        }
    }
    if (res > 32) {
        var wS = $(window).scrollTop();

        var elementToFixed = $('.cat-menu-col__inner');
        var elementToFixedWrap = $('.cat-menu-col');
        var menuHeight = menu.height();
        var catListHeight = $('.cat-list').outerHeight(true);
        var catListMargin = parseInt($('.center--catalog').css('margin-top'));

        var menuPos =
            $('.page-title').outerHeight() +
            $('header').height() +
            parseInt($('.page-content--catalog').css('padding-top')) +
            $('.center--cat-controls').height() +
            catListMargin;

        // var menuOffsetTop = menu.offset().top;
        var toBottomFixed = parseInt(menuPos + catListHeight);

        if (menuHeight < catListHeight) {
            if (wS < menuPos) {
                elementToFixedWrap.removeClass('menu-to-bottom');
                elementToFixed.removeClass('fixed');
            } else if (wS >= menuPos && menuHeight <= toBottomFixed - wS) {
                elementToFixedWrap.removeClass('menu-to-bottom');
                elementToFixed.addClass('fixed');
                posRemember = $(window).scrollTop();
            } else if (menuHeight > toBottomFixed - wS) {
                elementToFixedWrap.addClass('menu-to-bottom');
                elementToFixed.removeClass('fixed');
            }
        }
    }
}

$(window).on('load', function () {
    if ($('.cat-menu').length) {
        onLoadPosDefine();
    }
});
$(window).on('scroll  resize orientationchange', function () {
    if ($('.cat-menu').length) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            // downscroll
            catalogMenuPositionDefine(lastScrollTop);
        } else {
            // upscroll
            catalogMenuPositionDefine(lastScrollTop);
        }
        lastScrollTop = st;

        var res = resolutionCheck();
        if (res > 32 && $('body').hasClass('overlay-open')) {
            overlayEnd();
        }
    }
});
$(document).on('click', '.cat-accord__head', function () {
    if (
        ($('.cat-menu').length &&
            $('.cat-menu-col__inner').hasClass('fixed')) ||
        $('.cat-menu-col').hasClass('menu-to-bottom')
    ) {
        var wS = $(window).scrollTop();
        var rimHeight = parseInt(
            $('.cat-list').outerHeight() + $('.cat-list').offset().top
        );
        var menuHeight = $('.cat-menu-col__inner').height();

        var timerId = setInterval(function () {
            itemHeight = parseInt(
                $('.cat-menu-col__inner').height() +
                    $('.cat-menu-col__inner').offset().top
            );
            if (itemHeight > rimHeight) {
                $('.cat-menu-col__inner').removeClass('fixed');
                $('.cat-menu-col').addClass('menu-to-bottom');
            }
        }, 5);

        setTimeout(function () {
            clearInterval(timerId);
        }, timeDelayForCatMenu);
    }
});
